import api from "@/api";
export default {
  async fetchRFIs({ state }) {
    try {
      const level = state.users.user.level;
      const email = state.users.user.email;
      const response = await api.get(
        `${process.env.VUE_APP_API_BASE_URL || ""}/rfis/get-current-rfis`,
        { level, email }
      );
      if (response.ok) {
        return response;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },

  async updateRFI({ dispatch }, data) {
    try {
      const response = await api.put(
        `${process.env.VUE_APP_API_BASE_URL || ""}/rfis/update`,
        data
      );

      if (!response.ok) {
        dispatch("showSnackbar", "Error updating RFI.");
        throw new Error("Update failed");
      } else {
        dispatch("showSnackbar", "RFI updated sucessfully.");
      }

      return { success: true };
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  },

  async getNewURL(_, data) {
    try {
      const response = await api.get(
        `${process.env.VUE_APP_API_BASE_URL || ""}/rfis/get-new-url-attachment`,
        data
      );

      if (!response.ok) {
        throw new Error(response.data.error || "Fetch failed");
      }

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  },

  async getSSConfig() {
    try {
      const response = await api.get(
        `${process.env.VUE_APP_API_BASE_URL || ""}/rfis/get-smartsheet-config`
      );
      if (response.ok) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },

  async createRFI({ dispatch }, { rfiData, attachments = [] }) {
   

    try {
      const formData = new FormData();
      formData.append("rfiData", JSON.stringify(rfiData));

      if (attachments && attachments.length > 0) {
        attachments.forEach((file) => {
          formData.append("attachments", file);
        });
      }

      const response = await fetch(
        `${process.env.VUE_APP_API_BASE_URL || ""}/rfis/create-rfi`,
        {
          method: "POST",
          credentials: "include",
          headers: {
          },
          body: formData,
        }
      );


      if (!response.ok) {
        const errorData = await response.json();
        dispatch("showSnackbar", "Failed to add RFI");
        throw new Error(errorData.message || "Failed to create RFI");
      }

      const responseData = await response.json();
      dispatch("showSnackbar", "RFI Item created successfully!");
      return responseData;
    } catch (error) {
      console.error("Error adding RFI:", error);
      if (!error.message.includes("Failed to create RFI")) {
        dispatch("showSnackbar", "Error creating RFI");
      }

      throw error;
    }
  },
};
